import type { AnchorId } from '@beat-venues/common-types';
import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';

export interface SwimlaneProps
    extends CommonProps,
        VariantProps<typeof SwimlaneStyles> {
    anchorId?: AnchorId;
    children?: ReactNode;
    layout?: 'default' | 'vip' | 'mainBrand';
}

export const SwimlaneStyles = cva('mb-16 lg:mb-24', {
    variants: {
        layout: {
            default: '',
            vip: 'relative pt-12 pb-18 lg:pb-24 before:from-off-white-100 before:via-off-white-300 before:to-off-white-500 before:selection-ba before:absolute before:left-2/4 before:top-0 before:-z-10 before:h-full before:w-screen before:-translate-x-1/2 before:bg-gradient-to-b',
            mainBrand: 'relative pt-12 pb-18 lg:pb-24 bg-gradient-ba',
        },
    },
    defaultVariants: {
        layout: 'default',
    },
});

export const Swimlane = ({
    className,
    children,
    anchorId,
    layout,
    testId = 'swimlane',
    ...props
}: SwimlaneProps): JSX.Element => {
    return (
        <div
            className={twMerge(SwimlaneStyles({ className, layout }))}
            {...props}
            data-testid={testId}
            id={anchorId}
        >
            {children}
        </div>
    );
};
